export const enDictionary = {
    lineup: "Lineup",
    catchphrase: "Find Your Favorite Items",
    guide: {
        title: "Before You Purchase",
        subtitle: "Check in Advance",
        what_is_service: "What is Web ROLL?",
        delivery: "About Delivery",
        qa: "Frequently Asked Questions",
        contact: "Contact Us",
        guide_to_signup: "Is it your first time?",
        login: "Login",
        signup: "Free Membership Registration",
        link_login: "Login here",
        link_signup: "Register here",
        login_sns: "Easy login with SNS",
        signup_sns: "Easy registration with SNS",
        email_login: "Login with Email",
        email_signup: "Register with Email",
        google_login_support: "For customers who cannot log in with Google",
        login_form: {
            email: "Email",
            password: "Password",
            login_button: "Login with Email",
            signup_button: "Register with Email",
            agree: "Agree to",
            forgot_password: "Forgot your password"
        },
        login_alert: {
            title: "Register as a member\nto use\nWeb ROLL",
            description: "Easy registration with SNS",
            login_button: "Login",
            signup_button: "Free Membership Registration"
        }
    },
    gacha: {
        selling_status: {
            ended: "Sales Ended",
            selling: {
                day: "{{value}} days left",
                hour: "{{value}} hours left",
                minute: "{{value}} minutes left",
                absolute: "(Until  ~{{date}})"
            },
            comingsoon: {
                day: "{{value}} days until sale",
                hour: "{{value}} hours until sale",
                minute: "{{value}} minutes until sale",
                absolute: "(Scheduled to start on {{date}})"
            },
            play_limit: {
                reached_play_limit: "You have reached today's purchase limit",
                remaining_play_limit: "Remaining purchase opportunities today: {{value}} times"
            }
        },
        description: {
            more: "More",
            close: "Close"
        }
    },
    gift_code: {
        input: {
            title: "Enter Gift Code",
            cancel: "Cancel",
            scan_qr: "Scan QR Code",
            submit: "Add to Account",
            code_placeholder: "Enter gift code number here",
            require_code_error: "Please enter the gift code",
            or: "or"
        }
    },
    global: {
        header: {
            history: "History",
            menu: "Menu",
            signup_or_login: "SignUp / SignIn",
            menus: {
                mypage: "My Page",
                logout: "Sign Out",
                login: "Sign In",
                signup: "Sign Up",
                acquired_items: "Collected Items",
                input_code: "input by codes",
                gift_code: "Gift Code",
                play_ticket: "Free Ticket",
                prize_ticket: "Ticket / Coupon",
                user_id: "User ID : {{id}}"
            }
        },
        footer: {
            company: "Company Information",
            privacy: "Privacy Policy",
            terms: "Terms of Service",
            contact: "Contact Us",
            specified_commercial_transactions: "Specified Commercial Transactions"
        },
        login: {
            status: {
                google: "Logging in with Google",
                password: "Logging in with Email",
                unknown: "No login information"
            },
            success: "Login successful",
            error: {
                title: "Login failed",
                description: "If the problem persists, please use another authentication method"
            }
        },
        signup: {
            error: {
                title: "Signup failed",
                description: "If the problem persists, please use another authentication method"
            }
        },
        common: {
            tax: {
                included: "Tax included",
                excluded: "Excluding tax"
            },
            sum: "Total",
            piece: "time(s)",
            jst_date_warning: "Times listed are Japan Standard Time (JST)",
            delivery_fee: "Delivery fee",
            prize_unit: "unit",
            remain_delivery_count: "Free shipping on up to {{bundle_amount}} more",
            ok: "OK",
            cancel: "Cancel",
            register: "Register",
            submit: "submit",
            company: "Company Information",
            privacy: "Privacy Policy",
            terms: "Terms of Service",
            contact: "Contact Us",
            specified_commercial_transactions: "Specified Commercial Transactions"
        },
        adult_contents: {
            question_of_adulthood: {
                title: "Are you over 18 years old?",
                description: "In addition to general works, this content includes violence and sexual depictions that are not suitable for those under 18."
            },
            contents_switch: {
                general: "For General Audiences",
                adult: "Adult Content (R-18)"
            }
        }
    },
    components: {
        view_registered_address: "View registered shipping infos",
        shipping_forms: {
            country: "Country",
            name: "Full name",
            phone: "Phone number",
            zip_code: "Postal code",
            email: "Email address",
            full_address: "Full address",
            prefecture: "Prefecture",
            city: "City/Town/Village",
            address1: "District, street number",
            address2: "Apartment, condominium, room number",
            errors: {
                is_required: "Required",
                address_auto_fill_not_in_service: "Address search is only available for Japanese postal codes",
                is_invalid_phone_number: "Please enter a valid phone number",
                is_invalid_email: "Please enter a valid email address",
                is_invalid_zip_code: "Valid range is 3 to 9 digits"
            }
        },
        shipments: {
            title: "Shipping Information",
            about_bundle_capacity: "For every【{{amount}}】prizes",
            about_fee: "About the shipping fee",
            about_fee_detail: "▼Details about the shipping fee",
            period: "▼Estimated delivery time"
        },
        order_info: {
            play_ticket: "Free Ticket:",
            order_date: "Order date:",
            play_amount: {
                single: "{{amount}}-time lottery",
                multi: "{{amount}}-times lottery"
            },
            payment_method: {
                label: "Payment method:",
                no_info: "No payment information"
            },
            delivery: {
                title: {
                    delivery: "Delivery status:",
                    local_pickup: "Receiving Status:"
                },
                status: {
                    not_shipped: "Not shipped",
                    shipped: "Shipped",
                    not_picked: "Not picked up",
                    picked: "Picked up",
                    no_delivery: "This is an order with a non-delivery setting"
                }
            }
        }
    },
    pages: {
        gacha: {
            prizes: {
                about: "About the prizes",
                lineup: "List of prizes",
                view_collection: "View collected items"
            },
            purchase_benefits: "Purchase Benefits",
            collection_items: "Winning Products",
            collection: "Collection",
            "ticket/coupon": "Ticket / Coupon",
            guide_to_collection: "Winning digital content, tickets, and coupons can be viewed on the \"Winning Products\"",
            delivery: {
                price: "Delivery fee",
                detail: "About the delivery fee"
            },
            play: {
                single: "{{amount}}-time lottery",
                multi: "{{amount}}-times lottery",
                single_lottery: "Play {{amount}}-time",
                multi_lottery: "Play {{amount}}-times",
                button: "Play",
                view_play_buttons: "Play this gacha",
                has_play_ticket: "Can use a free ticket"
            },
            unplayable: {
                comingsoon: "Coming Soon",
                discontinued: "Sales Ended",
                soldout: "Sold Out",
                closing: "Sales are suspended"
            },
            result: {
                title: "Lottery Result"
            }
        },
        onePass: {
            invalid_format: "Please enter in the correct format",
            please_enter: "Please enter the code",
            please_login: "Please login",
            send_error: "An error occurred while sending the code"
        },
        local_pickup: {
            qr_code_title: "Pickup QR Code",
            qr_code_description: "Please present this QR code to the local staff to receive your item",
            display_qr_code: "Display QR code for pickup",
            pickup_code: "Code: ",
            user_reference_number: "Your Reference Number: ",
            calling_reference_number: "Calling Reference Number: ",
            pickup_location: "Pickup Location: ",
            pickup_location_detail: "Pickup Location Details",
            enter_prize_pickup: "Enter Prize Pickup",
            local_pickup_description: "This gacha is for venue pickup only"
        },
        check_in: {
            title: "Check-in",
            modal: {
                title: "This gacha is exclusive to attendees",
                description: "Once you arrive at the venue, tap 'Check-in' to verify your arrival",
                check_in_progress_1: "Are you near the venue,",
                check_in_progress_2: "checking..."
            },
            result: {
                success: "Check-in successful",
                not_nearby: {
                    title: "Check-in failed",
                    description: "Please try again near the venue"
                },
                permission_denied: {
                    title: "Location access not permitted",
                    ios_description: "Go to browser settings -> Website settings -> Location and select permit, then try again",
                    android_description: "Launch the settings app, go to Apps & notifications -> Advanced -> App permissions -> Location and turn on location for Chrome, then reload the page and try again"
                },
                get_location_failed: {
                    title: "Failed to obtain location",
                    description: "Please try again"
                }
            }
        },
        prize_ticket: {
            no_available_ticket: "No available tickets or coupons",
            used_ticket: "Used tickets or coupons"
        },
        my_page: {
            title: "Account",
            nickname: {
                edit: "Edit nickname",
                register: "Register nickname"
            },
            user_id: "User ID",
            shipping_info: {
                title: "Shipping Information",
                register: "Register shipping information",
                edit: "Edit shipping information"
            },
            delete_account: {
                title: "Delete account",
                modal: {
                    title: "Are you sure you want to delete your account?",
                    description: "Upon deleting your account, all registered personal information and purchase history will be deleted, and you will no longer be able to access or download any purchased digital content. Products that have not yet been shipped will be shipped as usual.",
                    agree: "Agree",
                    confirm: "Delete account",
                    cancel: "Cancel",
                    success: {
                        title: "Account deletion successful",
                        description: "Thank you for your use"
                    },
                    error: {
                        title: "Account deletion failed.",
                        description: "Please log in again and try once more."
                    }
                }
            }
        },
        buy: {
            title: "Enter Shipping Information",
            submit_title: "Purchase",
            buy_again: "Buy again",
            return_to_top: "Return to TOP",
            cancel: "Cancel",
            check_warning: {
                title: "Precautions",
                form_title: "I have confirmed the precautions"
            },
            shippings: {
                title: "Shipping Info",
                different_address_warning: "Changing the shipping information will incur a shipping fee",
                cannot_ship_warning: "The selected gacha cannot be delivered to the address registered on your account. Please enter a deliverable address.",
                forms: {
                    country: "Destination country",
                    name: "Full name"
                },
                no: {
                    title: "No shipping for won prizes",
                    description: "You can only view digital contents.",
                    warning: "The won prizes will not be shipped. Please be careful.",
                    confirm_title: "Are you sure you don't want your won prizes to be shipped?",
                    confirm_description: "Only viewing of digital contents is possible. Use this if you do not want to receive the won prizes by shipping."
                }
            },
            payments: {
                title: "Payment Method",
                methods: {
                    credit: "Credit Card",
                    paypay: "PayPay",
                    carrier: "Carrier Payment",
                    unionpay: "UnionPay"
                },
                credit: {
                    title: "Credit Card Information",
                    cardno: "Card Number",
                    exp: "Expiration Date",
                    holder_name: "Name",
                    security_code: "Security Code",
                    what_is_security_code: "What is a Security Code",
                    quantity_full: "When registering a new credit card, please remove the registered credit card",
                    register_card: "Register Credit Card",
                    supported_card_text: "We support the following card companies"
                },
                carrier: {
                    title: "Choose Carrier Payment"
                },
                purchase_detail_description: {
                    credit: "※Credit card details will be listed as \"SWAMP STORE\".\n\"SWAMP STORE\" is the purchase details for this service.",
                    app: "※App details will be listed as \"SWAMP STORE\".\n\"SWAMP STORE\" is the purchase details for this service."
                }
            },
            tipping_message: {
                title: "Send a message to the seller",
                placeholder: "Enter your message",
                invalid_length: "Message is too long",
                caution: "This message may be used in the creator's live stream, so please do not enter any inappropriate content."
            }
        },
        history: {
            title: "Purchase History",
            no_history: "No purchase history",
            guide_to_collection: "Digital content you have won can be viewed from the Winning Products.",
            items_not_yet_received: "Items not yet received",
            order_detail: {
                title: "Order Details"
            }
        }
    },
    country: {
        JP: "Japan",
        US: "United States",
        CN: "China",
        KR: "Korea",
        TW: "Taiwan",
        HK: "Hong Kong"
    },
    errors: {
        "404": {
            title: "The page for the specified URL does not exist",
            description: "The URL may be incorrect or the page may have been deleted. If the problem persists, please contact us from Account > Contact."
        },
        "500": {
            title: "An error has occurred",
            description: "If the problem persists, please contact us from Account > Contact Us."
        },
        not_found: {
            title: "The page for the specified URL does not exist",
            description: "The URL may be incorrect or the page may have been deleted. If the problem persists, please contact us from Account > Contact Us."
        },
        failed: {
            check_in: "Failed to check in.",
            get_gacha_detail: "Failed to retrieve event information.",
            get_gacha_history: "Failed to retrieve purchase history"
        }
    }
};
